import { render, staticRenderFns } from "./resolvability.vue?vue&type=template&id=6505c594&scoped=true"
import script from "./resolvability.vue?vue&type=script&lang=js"
export * from "./resolvability.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6505c594",
  null
  
)

export default component.exports